export const TYPES_FOLDER = {
  folder: 'folder',
  subfolder: 'subfolder'
}

export const ACTIVE_BUSINESS_UNITS = [
  'RESIDENCIAL',
  'COMERCIAL INDUSTRIAL',
  'PROYECTOS DE GENERACION'
]